/*
  Custom validation rules for registration form
*/

import {getRegistrationInvestorCategory} from "../../helpr/registrationFormData";

/*
  Check if the string is a member of the option list.
  Use key to map field to registrationFormData (Order model specific validation).
*/
export const optionsMember = (string, key) => {
  string = string.trim();
  switch(key) {
    case 'investorCategory': {
      return !(getRegistrationInvestorCategory().some(cls => cls.value.trim() === string));
    }
  }
}


